import { useState, useEffect, useRef } from 'react';
import { authContainer } from '../../di/container';

export type VerifyEmailStatus =
  | 'loading'
  | 'success'
  | 'invalid'
  | 'expired'
  | 'error';

/** Mapeia o `code` do erro do back para o estado da tela (§5.2). */
function statusForError(err: unknown): VerifyEmailStatus {
  const code =
    typeof err === 'object' && err !== null && 'response' in err
      ? (err as { response?: { data?: { error?: string } } }).response?.data
          ?.error
      : undefined;
  if (code === 'ACTION_TOKEN_NOT_FOUND') return 'invalid';
  if (code === 'TOKEN_EXPIRED' || code === 'TOKEN_ALREADY_USED')
    return 'expired';
  return 'error';
}

/**
 * Confirma o e-mail chamando `POST /auth/verify-email { token }` **uma vez** ao
 * montar. `useRef` protege do duplo-mount do StrictMode (em dev); o back também é
 * idempotente (§4.2), então reabrir o link mostra sucesso, nunca erro.
 */
export function useVerifyEmail(token: string | null): VerifyEmailStatus {
  const [status, setStatus] = useState<VerifyEmailStatus>('loading');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!token) {
      setStatus('invalid');
      return;
    }

    authContainer.repository
      .verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err: unknown) => setStatus(statusForError(err)));
  }, [token]);

  return status;
}
